module.exports={PASSPORT:"Pasaporte",NATIONAL_ID_CARD:"Documento nacional de identidad"};